import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { ReactNode } from 'react'
import { useStyles } from './styles'

export type TypefaceProps = {
    children: ReactNode
}

export const Info = ({ children }: TypefaceProps): React.ReactElement => {
    const theme = useTheme()
    const classes = useStyles(theme)

    return (
        <div className={classes.info}>
            <Typography>{children}</Typography>
        </div>
    )
}

export const Title = ({
    children,
    variant = 'h1',
}: TypefaceProps & { variant?: 'h1' | 'h2' | 'h4' | 'h6' }): React.ReactElement => {
    const theme = useTheme()
    const classes = useStyles(theme)

    return (
        <div className={variant === 'h1' ? classes.titleHeader : ''}>
            <Typography variant={variant}>{children}</Typography>
        </div>
    )
}

export const Subtitle = ({ children, variant = 'body1' }: TypefaceProps & { variant?: 'body1' }): React.ReactElement => {
    const theme = useTheme()
    const classes = useStyles(theme)

    return (
        <Typography className={classes.subtitle} variant={variant} component="div">
            {children}
        </Typography>
    )
}
